import {Injectable} from "@angular/core";
import { MasterMenuItemsService} from "./master-menu-items.service";
import {MenuItem} from "primeng/api";


@Injectable()
export class TramitesMenuItemsService extends MasterMenuItemsService {

  getMenuItems(translations: any, isLoggedIn: boolean): MenuItem[] {
    return [
      { label: translations.firmaElectronicaSolicitud, icon: 'icon-taxes-certificate', routerLink: ['/firma-electronica/solicitar'], visible: isLoggedIn },
      { label: translations.firmaElectronicaRenovacion, icon: 'icon-taxes-certificate', routerLink: ['/firma-electronica/renovar'], visible: isLoggedIn },
      { label: translations.firmaElectronicaRevocacion, icon: 'icon-taxes-certificate', routerLink: ['/firma-electronica/revocar'], visible: isLoggedIn },
      { label: translations.misFacturas, icon: 'pi pi-receipt', routerLink: ['/tramites/mis-facturas'], visible:  isLoggedIn },
      { label: translations.misPagos, icon: 'pi  pi-credit-card', routerLink: ['/tramites/mis-pagos'], visible:  isLoggedIn },
    ] as MenuItem[];
  }



}
